import React from "react";
import { MenuItem, TextField, Popper } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { LocationIcon, CheckmarkIcon } from "../icons";
import palette from "../styles/palette";
const useStyles = makeStyles(() => ({
  container: {
    minWidth: "10.938rem",
    maxWidth: "10.938rem",
  },
  iconContainer: {
    width: "1rem",
    paddingLeft: "0.625rem",
  },
  selectItem: {
    height: "1.5rem",
    width: "100%",
    display: "flex",
    fontSize: "0.875rem",
    justifyContent: "space-between",
  },
  popupIndicatorOpen: {
    transform: "rotate(0)",
  },
  inputRoot: {
    marginTop: "0.063rem",
  },
  input: {
    textAlign: "right",
    fontSize: "0.75rem",
    color: "white",

    "&::selection": {
      background: palette.typography.white.disabled,
    },
  },
  endAdornment: {
    top: "auto",
  },
  option: {
    padding: 0,
  },
  noOption: {
    padding: "0.5rem 1rem",
  },
}));

export default ({ value, items = [], onChange, onInputBlur }) => {
  const styles = useStyles();

  return (
    <Autocomplete
      options={items}
      openOnFocus
      blurOnSelect
      value={value}
      PopperComponent={({ style, ...props }) => (
        <Popper
          {...props}
          style={{ marginTop: "-0.22rem" }}
          placement="bottom-end"
        />
      )}
      onChange={(e, option) => {
        value !== option.value && onChange(option.value);
      }}
      popupIcon={<LocationIcon />}
      classes={{
        root: styles.container,
        popupIndicatorOpen: styles.popupIndicatorOpen,
        inputRoot: styles.inputRoot,
        input: styles.input,
        endAdornment: styles.endAdornment,
        option: styles.option,
        noOptions: styles.noOption,
      }}
      disableClearable
      getOptionSelected={(option, value) => {
        return option.value === value;
      }}
      getOptionLabel={(option) => {
        if (!option) return "";

        return typeof option === "string"
          ? items.find(({ value: optionValue }) => value === optionValue)?.label
          : option.label ?? null;
      }}
      renderOption={({ value: itemValue, label }) => (
        <MenuItem
          value={itemValue}
          key={itemValue}
          className={styles.selectItem}
          component="div"
        >
          {label}
          <div className={styles.iconContainer}>
            {value === itemValue && <CheckmarkIcon />}
          </div>
        </MenuItem>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          onBlur={(e) => {
            onInputBlur && onInputBlur(e.target.value);
          }}
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
            "data-testid": "autocomplete-input",
          }}
        />
      )}
    />
  );
};
